import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'of-auth-callback-page',
  standalone: true,
  imports: [CommonModule, MatProgressBarModule],
  template: `
    <div class="page">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  `,
})
export class AuthCallbackPage {}
